var path = 'msi/spinner/overlay/spinner-overlay.html';
var html = "<div class=\"og-msi-overlay\" ng-if=\"$ctrl.visible\">\n  <div class=\"og-backdrop\"></div>\n  <og-spinner></og-spinner>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;